(() => {
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const drawer = document.querySelector('#shop-cart');
  const age = document.querySelector('#shop-age');
  let opener;
  let busy = false;
  let addRecoveryRequired = false;
  const status = text => { const target = drawer?.querySelector('[data-shop-cart-status]'); if (target) target.textContent = text; };
  const messageOf = error => error instanceof Error ? error.message : 'No se pudo completar la operación.';
  function updateSticky() {
    document.querySelectorAll('[data-shop-sticky]').forEach(bar => {
      const visible = window.scrollY > window.innerHeight * .72;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    });
  }
  function initGalleries(scope = document) {
    scope.querySelectorAll('[data-shop-gallery]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const track = carousel.querySelector('[data-gallery-track]');
      const slides = [...track.querySelectorAll('.gallery-slide')];
      const counter = carousel.querySelector('[data-gallery-counter]');
      let index = 0;
      // Theme Editor briefly hides sections while resizing or selecting them.
      // Layout widths stay independent of editor transforms; ignore zero-size frames.
      let lastVisible = 1;
      const visibleCount = () => {
        const width = slides[0]?.offsetWidth || 0;
        if (width > 0 && carousel.clientWidth > 0) {
          lastVisible = Math.max(1, Math.min(slides.length, Math.round(carousel.clientWidth / width)));
        }
        return lastVisible;
      };
      const update = () => {
        const visible = visibleCount();
        index = Math.min(index, Math.max(0, slides.length - visible));
        track.style.transform = `translateX(-${index * 100 / visible}%)`;
        slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i < index || i >= index + visible)));
        counter.textContent = slides.length ? `${index + 1}-${Math.min(index + visible, slides.length)} / ${slides.length}` : '0 / 0';
        carousel.querySelectorAll('.gallery-control').forEach(button => { button.disabled = slides.length <= visible; });
      };
      const move = direction => {
        const visible = visibleCount(), max = Math.max(0, slides.length - visible), next = index + direction * visible;
        index = next > max ? 0 : next < 0 ? max : next;
        update();
      };
      carousel.querySelector('[data-gallery-prev]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-gallery-next]').addEventListener('click', () => move(1));
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      let start;
      carousel.addEventListener('touchstart', event => { start = event.touches[0]; }, {passive:true});
      carousel.addEventListener('touchend', event => {
        if (!start) return;
        const dx = event.changedTouches[0].clientX - start.clientX, dy = event.changedTouches[0].clientY - start.clientY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
        start = null;
      }, {passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(carousel);
      const cleanup = event => {
        if (event.target.contains(carousel)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', cleanup); }
      };
      document.addEventListener('shopify:section:unload', cleanup);
      update();
    });
  }
  window.addEventListener('scroll', updateSticky, {passive:true});
  window.addEventListener('resize', updateSticky, {passive:true});
  document.addEventListener('shopify:section:load', event => { initGalleries(event.target); updateSticky(); });
  initGalleries();
  updateSticky();
  document.documentElement.classList.add('hp-js');
  let cartStale = false;
  const setCartStatus = text => document.querySelectorAll('[data-shop-cart-status]').forEach(node => { node.textContent = text; });
  function lockCart(locked) {
    document.querySelectorAll('[data-shop-cart-form] input,[data-shop-cart-form] button').forEach(node => {
      if (locked && !node.disabled) { node.dataset.cartLocked = 'true'; node.disabled = true; }
      if (!locked && node.dataset.cartLocked) { node.disabled = false; delete node.dataset.cartLocked; }
    });
    document.querySelectorAll('[data-shop-cart-content]').forEach(node => node.setAttribute('aria-busy', String(locked)));
    if (cartStale) document.querySelectorAll('[data-shop-cart-form] [name=checkout]').forEach(node => { node.disabled = true; });
  }
  async function refresh() {
    const targets = [...document.querySelectorAll('[data-shop-cart-content]')];
    const ids = [...new Set(targets.map(node => node.dataset.sectionId))];
    const consent = targets.map(node => Boolean(node.querySelector('[name="attributes[Mayor de edad]"]')?.checked));
    // Keep the current template/preview context for Shopify's section renderer.
    const sectionUrl = new URL(window.location.href);
    sectionUrl.hash = '';
    sectionUrl.searchParams.set('sections', ids.join(','));
    const response = await fetch(sectionUrl, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('No pudimos actualizar el carrito.');
    const sections = await response.json();
    // Validate every rendered section before changing the UI, to avoid mixed totals.
    const replacements = targets.map((target, i) => {
      const html = sections[target.dataset.sectionId];
      if (!html) throw new Error('No pudimos actualizar el carrito.');
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shop-cart-content]');
      if (!content) throw new Error('No pudimos actualizar el carrito.');
      const checkbox = content.querySelector('[name="attributes[Mayor de edad]"]');
      if (checkbox) checkbox.checked = consent[i];
      return content;
    });
    targets.forEach((target,i) => target.replaceWith(replacements[i]));
    document.querySelectorAll('[data-shop-cart-count]').forEach(node => { node.textContent = replacements[0]?.dataset.count || '0'; });
    cartStale = false;
  }
  async function request(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'No se pudo completar la operación.');
    return data;
  }
  function openCart(control) {
    opener = control;
    if (!drawer.open) drawer.showModal();
  }
  function recovery(message) {
    cartStale = true;
    setCartStatus(message + ' Recarga el carrito para confirmar su estado antes de pagar.');
    document.querySelectorAll('[data-shop-cart-status]').forEach(node => {
      const link = document.createElement('a'); link.href = `${root}cart`; link.textContent = ' Recargar carrito'; node.append(link);
    });
  }
  async function changeQuantity(input, quantity, action) {
    if (busy || !Number.isSafeInteger(quantity) || quantity < 0) return;
    const key = input.dataset.key;
    const sectionId = input.closest('[data-shop-cart-content]').dataset.sectionId;
    busy = true; lockCart(true); setCartStatus('Actualizando tu selección…');
    try {
      await request(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      await refresh(); setCartStatus(quantity === 0 ? 'Producto eliminado.' : 'Cantidad y total actualizados.');
    } catch (error) {
      try { await refresh(); setCartStatus(messageOf(error)); }
      catch { recovery(messageOf(error)); }
    } finally {
      busy = false; lockCart(false);
      const scope = [...document.querySelectorAll('[data-shop-cart-content]')].find(node => node.dataset.sectionId === sectionId);
      const replacement = [...scope.querySelectorAll('[data-shop-quantity]')].find(node => node.dataset.key === key);
      const stepButton = replacement?.closest('[data-cart-line]')?.querySelector(`[data-quantity-step="${action}"]`);
      (stepButton || replacement || scope.querySelector('a,button'))?.focus();
    }
  }
  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    const open = target?.closest('[data-shop-cart-open]');
    if (open && drawer) {
      event.preventDefault(); openCart(open);
      if (!busy) {
        busy = true; lockCart(true); setCartStatus('Actualizando…');
        try { await refresh(); setCartStatus(''); } catch(error) { recovery(messageOf(error)); }
        finally { busy = false; lockCart(false); }
      }
    }
    const stepper = target?.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('[data-cart-line]').querySelector('[data-shop-quantity]');
      if (!input.reportValidity()) return;
      const direction = Number(stepper.dataset.quantityStep);
      const quantity = Math.max(0, Number(input.value) + direction * Number(input.step || 1));
      await changeQuantity(input, quantity, direction);
    }
    const remove = target?.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); await changeQuantity(remove.closest('[data-cart-line]').querySelector('[data-shop-quantity]'),0); }
    if (target?.closest('[data-shop-cart-close]')) drawer?.close();
    if (target?.closest('[data-nav-toggle]')) {
      const button = target.closest('[data-nav-toggle]');
      const nav = document.querySelector('[data-nav]');
      button.setAttribute('aria-expanded', String(nav.classList.toggle('is-open')));
    }
    if (target?.closest('[data-nav] a')) {
      document.querySelector('[data-nav]')?.classList.remove('is-open');
      document.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');
    }
  });
  drawer?.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelector('[data-nav]')?.classList.remove('is-open');
      document.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');
    }
  });
  document.addEventListener('submit', async event => {
    const newsletter = event.target.closest('[data-newsletter-form]');
    if (newsletter) {
      // Native POST retains Shopify's consent, CAPTCHA and double-opt-in handling.
      if (newsletter.dataset.submitting) { event.preventDefault(); return; }
      newsletter.dataset.submitting = 'true'; newsletter.setAttribute('aria-busy','true');
      newsletter.querySelector('[data-newsletter-submit]').disabled = true;
      newsletter.querySelector('[data-newsletter-status]').textContent = 'Enviando tu suscripción…';
      return;
    }
    const cartForm = event.target.closest('[data-shop-cart-form]');
    if (cartForm && (busy || cartStale)) { event.preventDefault(); setCartStatus('Confirma la actualización del carrito antes de continuar.'); return; }
    const form = event.target.closest('[data-shop-product-form]');
    if (!form || !drawer) return;
    event.preventDefault();
    if (busy || addRecoveryRequired) return;
    const button = form.querySelector('[type=submit]');
    const note = form.querySelector('[data-shop-product-status]');
    if (button.disabled) return;
    busy = true; button.disabled = true; lockCart(true); note.textContent = 'Agregando…';
    let added = false;
    try {
      await request(`${root}cart/add.js`, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      added = true;
      await refresh(); note.textContent = 'Producto agregado.'; openCart(button); setCartStatus('Producto agregado.');
    } catch(error) {
      // A lost add response does not prove that Shopify rejected the addition.
      // Reconcile before allowing a retry; never resend add.js automatically.
      const message = added ? 'Producto agregado. Revisa tu selección.' : `${messageOf(error)} Revisa tu carrito antes de volver a agregar.`;
      note.textContent = message;
      openCart(button);
      try { await refresh(); setCartStatus(message); }
      catch {
        addRecoveryRequired = true;
        recovery(message);
        document.querySelectorAll('[data-shop-product-form] [type=submit]').forEach(control => { control.disabled = true; });
      }
    } finally {
      busy = false; lockCart(false);
      const selected = form.querySelector('[data-shop-variant]')?.selectedOptions[0];
      button.disabled = addRecoveryRequired || (selected ? selected.dataset.available !== 'true' : false);
    }
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-newsletter-form]').forEach(form => {
      delete form.dataset.submitting; form.removeAttribute('aria-busy');
      const button = form.querySelector('[data-newsletter-submit]'); if(button) button.disabled = false;
      const note = form.querySelector('[data-newsletter-status]'); if(note) note.textContent = '';
    });
  });
  document.addEventListener('change', async event => {
    const input = event.target;
    if (input.matches('[data-localization]')) { input.form.requestSubmit(); return; }
    if (input.matches('[data-shop-variant]')) {
      const option = input.selectedOptions[0];
      const button = input.form.querySelector('[type=submit]');
      const available = option.dataset.available === 'true';
      button.disabled = addRecoveryRequired || !available;
      button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSold;
      document.querySelector('[data-variant-price]').textContent = option.dataset.price;
      return;
    }
    if (input.matches('[data-shop-quantity]')) {
      if (input.value.trim() === '') {
        input.value = input.defaultValue;
        setCartStatus('La cantidad no puede quedar vacía. Conservamos tu selección.');
        return;
      }
      if (input.reportValidity()) await changeQuantity(input,Number(input.value));
    }
  });
  if (age && !age.hasAttribute('data-design-mode')) {
    let confirmed = false;
    try { confirmed = sessionStorage.getItem('hanaq-shopify-age') === 'yes'; } catch { /* Use the dialog without persistent storage. */ }
    if (!confirmed) age.showModal();
    age.addEventListener('cancel', event => event.preventDefault());
    age.addEventListener('close', () => { if (age.returnValue === 'confirmed') { try { sessionStorage.setItem('hanaq-shopify-age','yes'); } catch { /* No persistence available. */ } } });
  }
})();
